var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null)

function Subscribe (el) {
	var formEl = $('.js-subscribe-form')
	var msgEl = $('.js-subscribe-form-msg')
	var inputEmail = el.querySelector('input[type="email"]')
	var inputFirstName = el.querySelector('input[name="first_name"]')
	var inputLastName = el.querySelector('input[name="last_name"]')
	var thankYouPage = el.dataset.thankYouPage

	formEl.on('submit', function (e) {
		e.preventDefault()

		if (inputEmail.validity.typeMismatch || inputEmail.validity.valueMissing) {
			inputEmail.reportValidity()
		}

		if (inputFirstName.validity.typeMismatch || inputFirstName.validity.valueMissing) {
			inputFirstName.reportValidity()
		}

		if (inputLastName.validity.typeMismatch || inputLastName.validity.valueMissing) {
			inputLastName.reportValidity()
		}

		msgEl.removeClass('is-error')
		msgEl.removeClass('is-success')

		var ajaxUrl = formEl.attr('action')

		if (inputEmail) {
			$.ajax({
				type: 'POST',
				headers: {'Content-Type': 'application/x-www-form-urlencoded'},
				contentType: 'application/x-www-form-urlencoded; charset=utf-8',
				dataType: 'json',
				url: ajaxUrl,
				data: formEl.serialize(),
				success: function (res) {
					if (res.code == 4001 || res.code == 4002 || res.code == 4400) {
						msgEl.addClass('is-error')
						msgEl.html(res.message)
					}

					if (res.success) {
						if (thankYouPage) {
							location.href = thankYouPage
						} else {
							msgEl.addClass('is-success')
							msgEl.html('Subscribe success.')
						}
					} else {
						msgEl.addClass('is-error')
						msgEl.html(res.message)
					}
				}
			})
			return false
		}
	})
}

module.exports = Subscribe
